// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"547e7f2f","341":"323e7bb5","562":"c418fdb4","934":"5868dd5d"}[chunkId] + ".chunk.css";
};